import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    /* Rows: padding / text / padding. */
    .bill-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .position-wrapper {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: row;
      width: 100%;
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
      text-wrap-style: pretty;
    }

    /* CMS justification: positions the half-width text column at 600px+;
       inert on mobile where the text column is full width. */
    .grid-left {
      justify-content: start;
    }

    .grid-center {
      justify-content: center;
    }

    .grid-right {
      justify-content: end;
    }

    /* Rich text arrives wrapped in its own p, which would otherwise reset to
       the body scale and ignore the CMS size wrapper around it. */
    .text-wrapper > * > p {
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }

    .italics {
      font-style: italic;
    }

    /* The CMS medium size option pins the title-small scale. */
    .font-size-medium {
      font-size: var(--fs-title-small);
      line-height: var(--lh-title-small);
      letter-spacing: var(--ls-title-small);
    }

    .elements-colors {
      background-color: #305371;
      color: #f8f8f8;
      padding: calc(40rem / var(--default-rem-px-count)) 0;
    }

    /* Keep the text inset from the colored box on mobile. */
    .elements-colors > .text-wrapper {
      margin: 0 calc(20rem / var(--default-rem-px-count));
    }

    .attribution {
      margin-top: calc(10rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .position-wrapper {
        grid-column: 2 / 14;
      }

      .text-wrapper {
        width: 50%;
        padding: calc(40rem / var(--default-rem-px-count)) 0;
      }

      .elements-colors > .text-wrapper {
        margin: 0;
      }

      .attribution {
        margin-top: calc(20rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      /* CMS column start/end arrive as inline custom props from index.js;
         the fallbacks keep the standard full-width span when unset. */
      .position-wrapper {
        grid-column: var(--bill-grid-column-start, 2) /
          var(--bill-grid-column-end, 14);
      }

      .text-wrapper {
        width: var(--bill-text-wrapper-width, 50%);
      }
    }
  `,
];
